import Button from "@/components/UI/Button/Button";
import { PublicPageZip } from "@/utils/page";
import { JobGetResponse } from "@/types/job";
import Section from "@/components/Section/Section";
import SectionContainer from "@/components/Section/SectionContainer";
import SectionHeader from "@/components/Section/SectionHeader";
import TextField from "@/components/UI/TextField/TextField";

interface Section22Props extends React.HTMLAttributes<HTMLElement> {
  job?: JobGetResponse;
  page: any;
  section: any;
}

const GetAccessSection = ({ job, page, section, ...props }: Section22Props) => {
  return (
    <Section section={section} {...props}>
      <SectionContainer className="lg:max-w-3xl" section={section}>
        <SectionHeader section={section} />
        <div className="flex justify-center gap-4">
          <TextField
            className="flex-1"
            id={section?.TextField?.HtmlId}
            name={section?.TextField?.Name}
            placeholder={section?.TextField?.Placeholder}
            size="large"
          />
          {section?.SubmitButton && <Button className="w-full max-w-[150px]">{section?.SubmitButton?.Value}</Button>}
        </div>
        {section?.Underline && <div className="text-center text-sm text-vpGray-700">{section?.Underline}</div>}
      </SectionContainer>
    </Section>
  );
};

export default GetAccessSection;
